const setAudio = () => {
  const remoteAudio = new window.Audio()
  remoteAudio.autoplay = true
  remoteAudio.crossOrigin = 'anonymous'
  window.audio = remoteAudio
}

const getAudio = () => window.audio

const setPhoneSession = phone => (window.phone = phone)

const getPhoneSession = () => window.phone

const setCall = call => (window.call = call)

const getCall = () => window.call

export {
  setPhoneSession,
  getPhoneSession,
  setAudio,
  getAudio,
  setCall,
  getCall,
}
